
import { defineComponent, reactive } from "vue";
import GradesTable from "./components/GradesTable.vue";
import GradeForm from "./components/GradeForm.vue";
import type { GradeData } from "./models";

export default defineComponent({
  name: "App",
  components: {
    GradesTable,
    GradeForm
  },
  setup() {
    const grades = reactive([] as GradeData[]);

    function addGrade(grade: GradeData) {
      grades.push(grade);
    }

    return { grades, addGrade };
  },
});
